export default {
    computed:{
        pxToRem:function(){
            return(px)=>{
                if(Array.isArray(px)){
                    let str = ""
                    px.forEach(p=>{
                        str+=(p/192).toFixed(3)+"rem "
                    })
                    return str
                }else{
                    return `${(px/192).toFixed(3)}rem`
                }
                
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/myMixin/index.js